import './index.less';
import { SimpleJobRevision } from 'domains/workspaceDomain';
import { Row } from 'antd';
import { SHIPPING_DATE_FORMAT } from 'components/RevxDate';
import moment from 'moment';
import RevxFlexLayout from 'components/RevxFlexLayout';

type Props = {
  revisionList: SimpleJobRevision[];
};

const JobRevision = ({ revisionList }: Props) => {
  return (
    <>
      {!!revisionList.length && (
        <div className="job-revision">
          <div className="total-job-cost">
            <label className="footer-left">Job Revision</label>
          </div>
          <div className="summary-card-container">
            <Row>
              {revisionList.map((i, index) => {
                return (
                  <RevxFlexLayout
                    key={index}
                    className="mb-10"
                    style={{ width: '100%' }}
                  >
                    <div>
                      <span>Change Request - </span>
                      {moment(i.createAt).format(SHIPPING_DATE_FORMAT)}
                    </div>
                    <div className="ml-40">
                      Version updated: Job ID - {i.revisionJobId}
                    </div>
                  </RevxFlexLayout>
                );
              })}
            </Row>
          </div>
        </div>
      )}
    </>
  );
};

export default JobRevision;
